<div class="row">
    <div class="col-12">
        <swiper
        [slidesPerView]="1"
        [spaceBetween]="0"
        [pagination]="{ clickable: true }"
        (swiper)="onWhySwiper($event)"
        (slideChange)="onWhySlideChange()"
        effect="fade"
        class="w-100"
        >
            <ng-template swiperSlide class="w-100 px-2" *ngFor="let quote of quotes">
                <div class="container-fluid p-0">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 d-lg-flex d-xl-flex flex-grow-1">
                            <div class="card shadow-xs">
                                <div style="position: relative;">
                                    <img loading="lazy" [src]="quote.image" class="card-img-top" [alt]="quote.image_alt ? quote.image_alt : quote.title"/>
                                    <img loading="lazy" src="assets/img/icons/icn-play.svg" *ngIf="quote.video" class="cursor-pointer" style="position: absolute; top: 40%; left: 50%; margin-left: -35px;" />
                                </div>
                                <div class="card-body d-block d-lg-none d-xl-none">
                                    <p class="font-size-16 text-dark" [innerHTML]="quote.quote | safeHtml"></p>
                                    <p class="font-size-16 text-dark font-weight-bold mb-0">{{ quote.author }}</p>
                                    <p class="font-size-16 text-dark">{{ quote.title }}</p>

                                    <img loading="lazy" *ngIf="quote.logo" [src]="quote.logo" [alt]="quote.logo_alt ? quote.logo_alt : quote.title" />
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 d-none d-sm-none d-md-none d-lg-flex d-xl-flex flex-grow-1">
                            <div class="custom-padded-block w-100 h-100">
                                <div class="bg-white rounded h-100 shadow-xs custom-padded-block-inner" style="position: relative;">
                                    <img loading="lazy" src="assets/img/icons/icn-quote.svg" style="width: 31px; position: absolute; top: 40px; left: 40px;" />
                                    <p class="font-size-16 text-dark" [innerHTML]="quote.quote | safeHtml"></p>
                                    <p class="font-size-16 text-dark font-weight-bold mb-0">{{ quote.author }}</p>
                                    <p class="font-size-16 text-dark">{{ quote.title }}</p>

                                    <img loading="lazy" *ngIf="quote.logo" [src]="quote.logo" [alt]="quote.logo_alt ? quote.logo_alt : quote.title" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </swiper>

        <ng-container *ngIf="quotes?.length > 1">
            <div class="swiper-buttons text-right d-none d-sm-none d-md-block">
                <button class="btn btn-white shadow-xs rounded-circle btn-previous" 
                        [class.disabled]="isBeginWhy" 
                        (click)="gotoWhyPrevious()"
                >
                    <mat-icon aria-hidden="false" aria-label="Previous">arrow_back</mat-icon>
                </button>
                <button class="btn btn-white shadow-xs rounded-circle btn-next" 
                        [class.disabled]="isEndWhy"
                        (click)="gotoWhyNext()"
                >
                    <mat-icon aria-hidden="false" aria-label="Next">arrow_forward</mat-icon>
                </button>
            </div>
        </ng-container>
    </div>
</div>